<template>
  <div id="app" :class="{ hasMinWidth: !hasMinWidth }">
    <template v-if="view">
      <router-view v-if="isRouterAlive" />
    </template>
    <no-support v-else />
  </div>
</template>

<script>
const NoSupport = () => import(/* webpackChunkName: 'no-support' */ '@/components/noSupport')
function isIE() {
  if (!!window.ActiveXObject || 'ActiveXObject' in window) return true
  else return false
}
function IEversion() {
  if (document.all && !window.XMLHttpRequest) return 6
  if (document.all && !document.querySelector) return 7
  if (document.all && !document.addEventListener) return 8
  if (document.all && !window.atob) return 9
  if (document.all && document.addEventListener && window.atob) return 10
  return 11
}
export default {
  components: {
    NoSupport
  },
  data() {
    return {
      isRouterAlive: true
    }
  },
  computed: {
    view() {
      return !isIE() || IEversion() > 9
    }
  },
  provide() {
    return {
      reload: this.reload,
      hasMinWidth: true
    }
  },
  created() {
    this.hasMinWidth = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)
    const that = this
    if (window.addEventListener) {
      window.addEventListener('message', that.messgeHandle, false)
    } else {
      window.attachEvent('onmessage', that.messgeHandle)
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function() {
        this.isRouterAlive = true
      })
    },
    messgeHandle(e) {
      if (e && e.data.shopId) {
        console.log('postmessage', e.data.shopId)
        window.openNewTab(`/store/${e.data.shopId}`, '_self')
      }
    }
  }
}
</script>
<style lang="scss">
  @import '~reset-css/sass/_reset';
  @import '~@/scss/variables';
  @import '~@/scss/index';

  *,
  *::before,
  *::after {
    box-sizing: border-box;
    outline: none;
  }
  #app {
    color: $--color-base;
    font-size: $--size-base;
    margin: 0 auto;
    height: 100%;
    // TODO: 2020-11-10 暂时设置
    //background: #fff;
    background: #f6f6f6;
  }
  .hasMinWidth {
    min-width: $--page-width;
    position: relative;
  }
  ///* 设置滚动条的样式 */
  //::-webkit-scrollbar {
  //  width: 16px;
  //  height: 3px;
  //}
  //
  ///* 滚动槽 */
  //::-webkit-scrollbar-track {
  //  border-radius: 10px;
  //}

  .text-ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  ///* 滚动条滑块 */
  //::-webkit-scrollbar-thumb {
  //  border-radius: 10px;
  //  background: rgba(0, 0, 0, 0.1);
  //}
  // 图片懒加载
  img[lazy='loading'] {
    // width: 100%;
    // height: 100%;
    background-position: center center !important;
    // background-size:100px 100px;
    background-repeat: no-repeat;
    -webkit-background-size: contain;
    -moz-background-size: contain;
    -o-background-size: contain;
    background-size: contain;
  }

  .customerServer {
    position: fixed;
    right: 40px;
    // background: red;
    bottom: 30px;
    z-index: 99999;
  }
</style>
